import { QADialog } from '~/components/Responsible/dialog/qa';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Self Assessment Questionnaire');
      },
      class: 'w-[500px] h-[700px]',
    },
  },
};

export default QADialog;
